import { render, staticRenderFns } from "./CreateUpdateModal.vue?vue&type=template&id=e0dd1f76&scoped=true&"
import script from "./CreateUpdateModal.vue?vue&type=script&lang=js&"
export * from "./CreateUpdateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0dd1f76",
  null
  
)

export default component.exports